import ResponsiveHeight from 'responsive-height';

export default () => {
    const containers = document.querySelectorAll('.location-list__items');

    if (!containers) {
        return;
    }

    for (const el of containers) {
        new ResponsiveHeight(el, {
            child: '.location-list__country',
            widths: [
                [1024, 4],
                [768, 3],
                [550, 2],
                [0, 1],
            ],
        });

        new ResponsiveHeight(el, {
            child: '.location-list__text',
            widths: [
                [1024, 4],
                [768, 3],
                [550, 2],
                [0, 1],
            ],
        });

        new ResponsiveHeight(el, {
            child: '.location-list__links',
            widths: [
                [1024, 4],
                [768, 3],
                [550, 2],
                [0, 1],
            ],
        });
    }
};
